export const page10 = {
  "name": "page10",
  "title": "The way you feel",
  "description": "To what extent do you agree with the following sentences?",
  "elements": [
    {
      "type": "rating",
      "name": "problem_dealing",
      "title": "I find it easy to deal with problems.",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Strongly disagree"
        },
        {
          "value": 2,
          "text": "Disagree"
        },
        {
          "value": 3,
          "text": "Neutral"
        },
        {
          "value": 4,
          "text": "Agree"
        },
        {
          "value": 5,
          "text": "Strongly agree"
        }
      ]
    },
    {
      "type": "rating",
      "name": "explosive_reactions",
      "title": "In the past 2 weeks, I have reacted very \"explosively\" to various external factors?",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Strongly disagree"
        },
        {
          "value": 2,
          "text": "Disagree"
        },
        {
          "value": 3,
          "text": "Neutral"
        },
        {
          "value": 4,
          "text": "Agree"
        },
        {
          "value": 5,
          "text": "Strongly agree"
        }
      ]
    },
    {
      "type": "rating",
      "name": "boredom",
      "title": "I am bored with everyday life",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Strongly disagree"
        },
        {
          "value": 2,
          "text": "Disagree"
        },
        {
          "value": 3,
          "text": "Neutral"
        },
        {
          "value": 4,
          "text": "Agree"
        },
        {
          "value": 5,
          "text": "Strongly agree"
        }
      ]
    },
    {
      "type": "rating",
      "name": "breakdown",
      "title": "I have been on the venge of a breakdown over the past 2 weeks?",
      "isRequired": true,
      "autoGenerate": false,
      "rateValues": [
        {
          "value": 1,
          "text": "Strongly disagree"
        },
        {
          "value": 2,
          "text": "Disagree"
        },
        {
          "value": 3,
          "text": "Neutral"
        },
        {
          "value": 4,
          "text": "Agree"
        },
        {
          "value": 5,
          "text": "Strongly agree"
        }
      ]
    }
  ]
};